import React from 'react';

import { useIntl } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import SystemErrorSection from '../../components/SystemErrorSection/SystemErrorSection';
import MobileBottomNavbar from '../../components/MobileBottomNavbar/MobileBottomNavbar';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

// Full-page fallback for a genuine render crash caught by
// LoadableComponentErrorBoundary (see src/routing/Routes.js). Unlike
// NotFoundPage, this never redirects - a system error must be visibly a
// system error, not something that quietly lands the customer somewhere
// else looking like nothing went wrong.
const SystemErrorPage = () => {
  const intl = useIntl();

  const handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    <Page
      title={intl.formatMessage({ id: 'SystemErrorPage.title' })}
      scrollingDisabled={false}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
        mobileBottomNavbar={<MobileBottomNavbar />}
      >
        <SystemErrorSection onRetry={handleReload} />
      </LayoutSingleColumn>
    </Page>
  );
};

export default SystemErrorPage;
